import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999 // Increase z-index value
    })
};

const SearchableDropdown = React.memo(({ options, selectedOptions, setSelectedOptions, ...props }) => {
    return <Select styles={customStyles} defaultValue={selectedOptions} onChange={setSelectedOptions} options={options} {...props} />;
});

SearchableDropdown.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedOptions: PropTypes.object
};

SearchableDropdown.defaultProps = {
    options: [],
    selectedOptions: null
};

export default SearchableDropdown;
